import type { CampingSpot } from '../types';

/**
 * Normaliser et rått `cached_spots`-dokument til en render-klar CampingSpot.
 *
 * To ting gjør rå `d.data()` utrygg å bruke direkte:
 *  1. Eldre/seedede docs kan mangle gyldig nested `location` (flat-formede
 *     seed-docs) — de kan ikke vises og returneres som null.
 *  2. Cloud-seederen for campingplasser skrev docs UTEN `id`-felt i data
 *     (id-en var kun dokument-ID). Nedstrøms filtre som `s.id.startsWith(...)`
 *     krasjet da på undefined («undefined is not an object (evaluating
 *     'pe.id.startsWith')», error_reports 2026-07-16). Dokument-ID-en brukes
 *     derfor som fallback når feltet mangler.
 */
export function normalizeCachedSpotDoc(docId: string, data: unknown): CampingSpot | null {
  const d = data as Partial<CampingSpot> | null | undefined;
  if (
    !d ||
    !d.location ||
    typeof d.location.latitude !== 'number' ||
    typeof d.location.longitude !== 'number'
  ) {
    return null;
  }
  return { ...(d as CampingSpot), id: d.id || docId };
}
